var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prose-mirror-editor-v2',{key:_vm.namespace,staticClass:"pm-container",attrs:{"namespace":_vm.namespace,"projectId":_vm.projectId,"entityId":_vm.entityId,"paneIdx":_vm.paneIdx},on:{"onUserListUpdate":_vm.onUserListUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }